import PosterContent from './PosterContent';

export default PosterContent;
